var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("VueGoodTable", {
    ref: "table",
    attrs: {
      columns: _vm.columnsConfig,
      rows: _vm.rows,
      "pagination-options": _vm.paginationOptions,
      "search-options": _vm.searchOptions,
      selectOptions: _vm.selectOptions
    },
    on: { "on-selected-rows-change": _vm.onSelectionChanged }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }